import * as React from 'react';
import { Button } from 'reactstrap';
import { Field, withFormik } from 'formik';
import * as Yup from 'yup';
import { TextInput, CheckboxGroup, Checkbox } from './FormElements';

import './RejectForm.scss';

const TypeRejection = {
  INDEPENDENT: 'INDEPENDENT',
  INDEPENDENT_BR: 'INDEPENDENT_BR',
};

const limitLength = 230;
let letterCount = 230;

const softReject = withFormik({
  enableReinitialize: true,
  mapPropsToValues: () => ({
    rejectionCauses: '',
    comments: '',
  }),
  validationSchema: Yup.object().shape({
    comments: Yup.string().required(
      'A Comment is required when rejecting a task submission.',
    ),
    rejectionCauses: Yup.string().required(
      'A Reason is required when rejecting a task submission.',
    ),
    // comments: Yup.string().required('A comment is required.'),
  }),

  handleSubmit: async (payload, { props, setSubmitting, setErrors }) => {
    try {
      const errors = await props.handleSubmit(payload);
      setSubmitting(false);
      if (errors) {
        setErrors(errors);
      }
    } catch (e) {
      throw e;
    }
  },
  displayName: 'RejectForm',
});

const softRejectForm = (props) => {
  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    closeForm,
    optionsData,
    setFieldTouched,
    values,
  } = props;

  const handleReasonsInComments = (target) => {
    setFieldValue('rejectionCauses', target);
    let reasons = '';
    if (target) {
      target.forEach((elem) => {
        const item = optionsData.data.find((v) => v.id === Number(elem));
        const temp = item ? item.reasonString : '';
        reasons = reasons.concat(temp, ' ');
      });
      reasons =
        reasons.length >= limitLength
          ? reasons.substring(0, limitLength)
          : reasons;
      letterCount = limitLength - reasons.length;
      setFieldValue('comments', reasons);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <b>Independientes</b>
      </div>
      <CheckboxGroup
        id='rejectionCauses'
        value={values.rejectionCauses ? values.rejectionCauses : []}
        error={errors.rejectionCauses}
        touched={touched.rejectionCauses}
        onChange={(e, target) => handleReasonsInComments(target)}
        onBlur={setFieldTouched}
        className='rejectCheckboxGroup'
      >
        {optionsData && optionsData.data
          ? optionsData.data
              .filter((v) => v.typeRejection === TypeRejection.INDEPENDENT)
              .map((option, index) => (
                <Field
                  key={index}
                  component={Checkbox}
                  name='rejectionCauses'
                  id={option[optionsData.key]}
                  label={option[optionsData.value]}
                />
              ))
          : ''}
      </CheckboxGroup>
      <div>
        <b>Independientes_BR</b>
      </div>
      <CheckboxGroup
        id='rejectionCauses'
        value={values.rejectionCauses ? values.rejectionCauses : []}
        error={errors.rejectionCauses}
        touched={touched.rejectionCauses}
        onChange={(e, target) => handleReasonsInComments(target)}
        onBlur={setFieldTouched}
        className='rejectCheckboxGroup'
      >
        {optionsData && optionsData.data
          ? optionsData.data
              .filter((v) => v.typeRejection === TypeRejection.INDEPENDENT_BR)
              .map((option, index) => (
                <Field
                  key={index}
                  component={Checkbox}
                  name='rejectionCauses'
                  id={option[optionsData.key]}
                  label={option[optionsData.value]}
                />
              ))
          : ''}
      </CheckboxGroup>

      <div>Comments for user ({letterCount})</div>
      <TextInput
        id='comments'
        type='textarea'
        label={props.commentsLabel}
        labelClassName='sr-only'
        placeholder={props.commentsLabel}
        limitLength={limitLength}
        error={touched.comments && errors.comments}
        onChange={(e) => {
          handleChange(e);
          letterCount = limitLength - e.target.value.length;
        }}
        onBlur={handleBlur}
        value={values.comments}
      />
      <Button
        type='submit'
        color='primary'
        disabled={!props.isValid || isSubmitting}
      >
        Soft Rejection :-(
      </Button>
      {isSubmitting && <div className='loader'>Loading...</div>}
      <Button
        color='primary'
        onClick={(e) => {
          letterCount = limitLength;
          closeForm(e);
        }}
      >
        Cancel
      </Button>
    </form>
  );
};

export const SoftRejectForm = softReject(softRejectForm);
